import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import envelopeOpenIcon from "@phosphor-icons/core/regular/envelope-open.svg";

const CoeditingDocumentTool = lazy(
    () => import("../renderers/coediting-document-tool.tsx"),
);

export const letterOfRecommendation: Tool = {
    urlSlug: "letter-of-recommendation",
    configName: "teacher-tool-letter-of-recommendation",
    title: () => t`Letter of recommendation`,
    description: () => t`Create personalized letters of recommendation`,
    categories: [ToolCategories.Create],
    icon: envelopeOpenIcon,
    color: color.fadedGreen24,
    layout: Layout.Coeditor,
    activitySlug: "activity-write-recommendation-letter",
    reportingLabelId: "write-recommendation-letter",
    exportTargets: [
        "print",
        "download-pdf",
        "download-docx",
        "google-drive-docx",
        "microsoft-onedrive-docx",
    ],
    requestedInputs: [
        {
            description: () =>
                t`Optional. If not provided, we'll use a placeholder like [Student Name].`,
            inputKind: "TEXT_BOX",
            label: () => t`Student's first name`,
            variableName: "studentName",
            // TODO(reid): Figure out how name replacement should work
            // in Classroom/coediting v2.
            // shouldReplaceName: true,
        },
        {
            description: () =>
                t`Be specific with the name of summer program, college, or other opportunity.`,
            inputKind: "TEXT_BOX",
            label: () => t`What will this recommendation be used for?`,
            required: true,
            variableName: "purpose",
        },
        {
            description: () =>
                t`List details of your relationship (name of class, how long have you known them, etc.).`,
            inputKind: "TEXT_BOX",
            label: () => t`How do you know the student?`,
            required: true,
            variableName: "relationship",
        },
        {
            description: () =>
                t`List qualities to highlight and accomplishments to celebrate (e.g., "warm leader, thoughtful, led the math club, worked a job while studying")`,
            inputKind: "TEXT_AREA",
            label: () =>
                t`Qualities and accomplishments (be as specific as possible)`,
            required: true,
            variableName: "details",
        },
        {
            description: () =>
                t`Share an area or direction in which you hope for further growth.`,
            inputKind: "TEXT_AREA",
            label: () => t`Growth opportunities (be as specific as possible)`,
            required: true,
            variableName: "growthAreas",
        },
    ],
    component: ({providedInputs, configName, debugMode}) => {
        return (
            <CoeditingDocumentTool
                configName={configName}
                providedInputs={providedInputs}
                debugMode={debugMode}
            />
        );
    },
};
